import { SYMBOL_FONTS } from '@/constants';
import insertSymbolAvailable from './insertSymbolAvailable';
export default (function (section) {
    var isSpecialSymbolMaterial = insertSymbolAvailable();
    var isSpecialSymbolInserted = [
        SYMBOL_FONTS.MANDATORY,
        SYMBOL_FONTS.PROHIBITION,
        SYMBOL_FONTS.GHS,
        SYMBOL_FONTS.WARNING,
    ].includes(section.symbolFont);
    return isSpecialSymbolMaterial ? isSpecialSymbolInserted : false;
});
